(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('formdata', (event) => {
  const form = event.target;
  if (!form.matches('form[data-sp-query]')) return;
  const input = form.querySelector('input[name="q"]');
  if (input && input.value.trim().toLowerCase() === form.dataset.spQueryLabel.toLowerCase()) {
    event.formData.set('q', form.dataset.spQuery);
  }
});
  } catch(e) { console.error(e); }
})();

})();
